import React, { useCallback, useEffect, memo, useState } from "react";
import { Button, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import MenuSidebar from "./Components/MenuSidebar";
import AdminHeader from "../Admin/Components/AdminHeader";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faSpinner,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

import {
  deleteVenueAction,
  getVenuesAction,
} from "../../Services/Store/Actions/VanuesAction";
import VenuesSpaceList from "../Admin/Components/VenuesSpaceList";
import AddVenue from "../../Components/Modals/AddVenue";
import { VenueTypes } from "../../Constants/Interfaces";
import { formatArea, showToast } from "../../utils/helpers";
import PanelWrapper from "./PanelWrapper";
import ConfirmationModal from "../../Components/ConfirmationModal";
import ActionMenu from "../../Components/ActionMenu";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../Components/Pagination";

const PropertiesList = () => {
  const dispatch = useDispatch();
  const { myVanues } = useSelector((state: any) => state.venues);

  const [loading, setLoading] = useState(false);
  const [venueList, setVenueList] = useState([]);
  const [deletingVenue, setDeletingVenue] = useState({});

  const [addNew, setNewVenue] = useState({ show: false, item: {} });

  const [showConfimation, setShowConfimation] = useState({
    show: false,
    item: null,
  });

  const [pagination, setPagination] = useState({
    totalItems: null,
    itemsPerPage: null,
    currentPage: null,
    totalPages: null,
    nextPage: null,
  });

  const [showRightPanel, setShowRightPanel] = useState({
    show: false,
    item: {},
  });

  const getVenueList = useCallback((page = 1) => {
    if (!loading) {
      setLoading(true);

      const data = {
        page,
        limit: 15,
        addresss: "",
        size: "",
        spaces: "",
      };

      getVenuesAction(data, dispatch)
        .then((res) => {
          //
          if (res.type === "success") {
            setPagination(res.pagination);
          }
        })
        .catch((err) => {
          //
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  const deleteVenue = (item: VenueTypes & { id: string }) => {
    const venueId = item.id;

    if (!deleteVenue[venueId]) {
      // const confirmDel = window.confirm(
      //   `Are you sure you want to delete the venue ${item.name}?`
      // );

      setDeletingVenue({ ...deleteVenue, [venueId]: true });

      deleteVenueAction({ id: venueId }, dispatch)
        .then((res) => {
          if (res.type === "success") {
            showToast("success", res.message || "Venue deleted successfully.");
          } else {
            showToast(res.type, res.message);
          }
        })
        .catch((err) => {
          showToast("error", err.message);
        })
        .finally(() => setDeletingVenue({ ...deleteVenue, [venueId]: false }));
    }
  };

  useEffect(() => {
    if (myVanues) {
      setVenueList(myVanues);
    } else {
      setVenueList([]);
    }
  }, [myVanues]);

  useEffect(() => {
    getVenueList();
  }, []);

  return (
    <PanelWrapper>
      <div className="container">
        <div className="page-header">
          <h2>Venues</h2>

          <Button onClick={() => setNewVenue({ show: true, item: {} })}>
            Add New
          </Button>
        </div>

        <div className="page-content-card">
          <div className="content-card-header">
            <h3>List of Venues</h3>

            {/* <div className="filter-area">
                  <div className="form-group">
                    <select className="form-control">
                      <option>Location</option>
                      <option value="Location1">Location 1</option>
                      <option value="Location2">Location 2</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <select className="form-control">
                      <option>Property Size</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <select className="form-control">
                      <option>Number of Space</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                    </select>
                  </div>
                </div> */}
          </div>

          <div className="listing-tables">
            <Table responsive>
              <thead>
                <tr>
                  <th>Property Name</th>
                  <th>Spaces</th>
                  <th>Location</th>
                  <th>Property Size</th>
                  <th>Status</th>
                  <th className="action-col">Action</th>
                </tr>
              </thead>

              <tbody>
                {loading && (
                  <tr>
                    <td colSpan={6} align="center">
                      <FontAwesomeIcon icon={faSpinner} spin />
                    </td>
                  </tr>
                )}

                {!loading && (!venueList || venueList.length === 0) && (
                  <tr>
                    <td colSpan={6} align="center">
                      No Venues Created
                    </td>
                  </tr>
                )}

                {!loading &&
                  venueList &&
                  venueList.map((item, index) => {
                    return (
                      <tr key={`property-${index}`}>
                        <td
                          className="as-link"
                          onClick={() => setNewVenue({ show: true, item })}
                        >
                          {item.name}
                        </td>
                        <td>
                          {Array.isArray(item.spaces)
                            ? item.spaces.length
                            : item.spaces_count ?? item.spacesCount ?? 0}
                        </td>
                        <td>{item?.address}</td>
                        <td>{formatArea(item?.area)} sqft</td>
                        <td>
                          {(() => {
                            const status = String(
                              item?.status || ""
                            ).toLowerCase();
                            const label =
                              status === "blocked"
                                ? "Blocked"
                                : status === "draft"
                                ? "Draft"
                                : "Published";
                            const cls =
                              status === "blocked"
                                ? "status-blocked"
                                : status === "draft"
                                ? "status-draft"
                                : "status-published";
                            return (
                              <span className={`status-badge ${cls}`}>
                                {label}
                              </span>
                            );
                          })()}
                        </td>
                        <td className="action-col">
                          <ActionMenu
                            items={[
                              {
                                label: "Manage Spaces",
                                icon: faChevronRight,
                                onClick: () =>
                                  setShowRightPanel({ show: true, item }),
                              },
                              {
                                label: "Edit",
                                icon: faPen,
                                onClick: () =>
                                  setNewVenue({ show: true, item }),
                              },
                              {
                                label: "Delete",
                                icon: faTrash,
                                variant: "danger",
                                loading: deletingVenue[item.id],
                                onClick: () =>
                                  setShowConfimation({ show: true, item }),
                              },
                            ]}
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>

              <tfoot>
                <tr>
                  <td colSpan={6}>
                    <Pagination
                      pagination={pagination}
                      onPageChange={(page) => getVenueList(page)}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </div>
      </div>

      {showRightPanel.show && (
        <VenuesSpaceList
          show={showRightPanel.show}
          venue={showRightPanel.item}
          onClose={() => setShowRightPanel({ show: false, item: {} })}
          addNew={true}
        />
      )}

      {addNew.show && (
        <AddVenue
          show={addNew.show}
          item={addNew.item}
          closeModal={() => setNewVenue({ show: false, item: {} })}
        />
      )}

      {showConfimation.show && (
        <ConfirmationModal
          show={showConfimation.show}
          heading="Delete Venue"
          message={`Are you sure you want to delete the venue ${showConfimation?.item?.name}?`}
          closeModal={() => setShowConfimation({ show: false, item: null })}
          buttons={[
            {
              text: "Yes",
              action: () => {
                deleteVenue(showConfimation.item);
                setShowConfimation({ show: false, item: null });
              },
            },
            {
              text: "Cancel",
              variant: "outline-dark",
              className: "confirmation-cancel-btn",
              action: () => setShowConfimation({ show: false, item: null }),
            },
          ]}
        />
      )}
    </PanelWrapper>
  );
};

export default PropertiesList;
